export const enums = {
  STATUS: {
    ACTIVE: "ACTIVE",
    UNACTIVE: "UNACTIVE",
  },
  COURSETYPE: {
    GENERAL: "CT_01",
    SHORT: "CT_02",
  },
  COURSETYPENAME: {
    GENERAL: "General Course",
    SHORT: "Short Course",
  },
  COURSESTATUS: {
    OPEN: "OPEN",
    CLOSE: "CLOSE",
    CLOSETEMPORARY: "CLOSE_TEMPORARY",
    RESERVE: "RESERVE",
    DRAFT: "DRAFT",
  },
  PACKAGECODE: {
    EXCLUSIVE: "PACKAGE-001",
    FAMILY: "PACKAGE-002",
    GROUP: "PACKAGE-003",
  },
  ROLE: {
    GUEST: "GUEST",
    PARENT: "PARENT",
    STUDENT: "STUDENT",
    ADMIN: "ADMIN",
    COACH: "COACH",
  },
  //--------------  LEAVE + ATTENDANCE ---------------

  LEAVETYPE: {
    SICK: "SICK",
    ANNUAL: "ANNUAL",
    BUSSINESS: "BUSSINESS",
  },

  LEAVERANGE: {
    FULL: "FULL",
    MORNING: "MORNING",
    AFTERNOON: "AFTERNOON",
  },

  LEAVESTATUS: {
    APPROVE: "APPROVE",
    REJECT: "REJECT",
    CANCEL: "CANCEL",
    PENDING: "PENDING",
  },
  CHECKINSTATUS: {
    PUNCTUAL: "PUNCTUAL",
    LATE: "LATE",
    EMERGENCY_LEAVE: "EMERGENCY_LEAVE",
    ABSENT: "ABSENT",
    LEAVE: "LEAVE",
    NOT_CHECKIN: "NOT_CHECKIN",
  },

  // -------  FINANCE + RESERVE --------------

  FINANCESTATUS: {
    SUCCESS: "SUCCESS",
    PENDING: "PENDING",
    CANCEL: "CANCEL",
    FAIL: "FAIL",
  },
  PAYMENTSTATUS:{
    SUCCESS : 'Success',
    FAIL : 'Fail',
    CANCEL : 'Cancel',
    DATA_INCOMPLETE : 'Data Incomplete'
  },
  PAYMENTMETHOD: {
    CREDIT_CARD: 'Credit Card',
    CREDIT_CARD_INSTALLMENT: 'Credit Card Installment',
    INTERNET_BANKING: 'Internet Banking',
    CORPORATE_BANKING: 'Corporate Banking',
    QR_CODE_PAYMENT: 'QR Code Payment',
    CASH: 'Cash',
    TRANSFER: 'Transfer',
  },

  RESERVESTATUS: {
    WAITING: "WAITING",
    CONFIRMED: "CONFIRMED",
    CANCELLED: "CANCELLED",
  },
  FOLDER: {
    EVENTS: "EVENTS",
  },

  STUDENTSTATUS: {
    ALL: "ALL",
    CURRENT: "CURRENT",
    ALMOST_COMPLETE: "ALMOST_COMPLETE",
    RESERVE: "RESERVE",
  },
  SEATSTATUS: {
    ALL: "ALL",
    FULL: "FULL",
    AVAILABLE: "AVAILABLE",
  },
  NOTIFYTYPE:{
    CHECKIN: "CHECKIN",
    ASSESSMENT: "ASSESSMENT",
    POTENTIAL: "POTENTIAL",
    COACH_SUMMARY: "COACH_SUMMARY",
    PENDING_COURSE: "PENDING_COURSE",
    APPROVE_RESERVE: "APPROVE_RESERVE"
  },
};
